var map = {
	"./pages/district-rankings/district-rankings.module": [
		"./src/app/pages/district-rankings/district-rankings.module.ts",
		"pages-district-rankings-district-rankings-module"
	],
	"./pages/event-rankings/event-rankings.module": [
		"./src/app/pages/event-rankings/event-rankings.module.ts",
		"pages-event-rankings-event-rankings-module"
	],
	"./pages/match-schedule/match-schedule.module": [
		"./src/app/pages/match-schedule/match-schedule.module.ts",
		"pages-match-schedule-match-schedule-module"
	],
	"./pages/scouting/scouting.module": [
		"./src/app/pages/scouting/scouting.module.ts",
		"common",
		"pages-scouting-scouting-module"
	],
	"./pages/team-info/team-info.module": [
		"./src/app/pages/team-info/team-info.module.ts",
		"common",
		"pages-team-info-team-info-module"
	],
	"./pages/teams/teams.module": [
		"./src/app/pages/teams/teams.module.ts",
		"pages-teams-teams-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;